"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "anzola-dell-emilia": {
    "43c1a5fb": [{
      "hkey": "320bbfc3",
      "slug": "ponte-samoggia-castelletto",
      "name": "Ponte Samoggia-Castelletto",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-samoggia-santa-maria-in-strada": [{
      "hkey": "320bbfc3",
      "slug": "ponte-samoggia-castelletto",
      "name": "Ponte Samoggia-Castelletto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;